import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { categories } from "@/data/products";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-sm border-b">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="font-display text-xl sm:text-2xl font-semibold tracking-tight">
            {/*ESSENZA*/}
            <img width={150} src="/images/ragazza20261.svg" alt="logo" />
          </Link>

          {/* Desktop nav */}
          {/* <nav className="hidden md:flex items-center gap-8">
            {categories.filter(c => c !== "Todos").map((cat) => (
              <Link
                key={cat}
                to={`/?categoria=${cat}`}
                className="text-sm tracking-wide text-muted-foreground hover:text-foreground transition-colors"
              >
                {cat}
              </Link>
            ))}
          </nav> */}

          {/* Mobile toggle */}
          {/* <button
            className="md:hidden p-2 -mr-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menú"
          >
            {menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button> */}
        </div>

        {/* Mobile nav */}
        {menuOpen && (
          <nav className="md:hidden pb-4 border-t pt-4 flex flex-col gap-3">
            {categories.filter(c => c !== "Todos").map((cat) => (
              <Link
                key={cat}
                to={`/?categoria=${cat}`}
                className="text-sm tracking-wide text-muted-foreground hover:text-foreground transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                {cat}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
